import { render, staticRenderFns } from "./GoalProfileName.vue?vue&type=template&id=cf6d2c0e"
import script from "./GoalProfileName.vue?vue&type=script&lang=js"
export * from "./GoalProfileName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports